export const VerificationMethodStatusEnum = {
	PENDING: "Pending",
	SUCCESS: "Success",
	FAILED: "Failed",
	EXHAUSTED: "Exhausted"
};
